/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.multi.account.configuration.manager.rpc.MultiAccountOrganizationChirpService
 */

export const getOrganizationDetailsRpc = {
  serviceName: 'com.hubspot.multi.account.configuration.manager.rpc.MultiAccountOrganizationChirpService',
  rpcName: 'getOrganizationDetails',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABIayArQ_41rMheTORhNAPH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateOrgDataSharingConnectionsRpc = {
  serviceName: 'com.hubspot.multi.account.configuration.manager.rpc.MultiAccountOrganizationChirpService',
  rpcName: 'updateOrgDataSharingConnections',
  auth: 'app',
  fingerprint: 'o_vDQj-BzFRnTwybrcrm0cheTORhNAPH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateOrgCopyAssetConnectionsRpc = {
  serviceName: 'com.hubspot.multi.account.configuration.manager.rpc.MultiAccountOrganizationChirpService',
  rpcName: 'updateOrgCopyAssetConnections',
  auth: 'app',
  fingerprint: 'M4xbg5m11eJnTwybrcrm0cheTORhNAPH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateReportingSharingConnectionsRpc = {
  serviceName: 'com.hubspot.multi.account.configuration.manager.rpc.MultiAccountOrganizationChirpService',
  rpcName: 'updateReportingSharingConnections',
  auth: 'app',
  fingerprint: 'nZzv0FFb3PZnTwybrcrm0cheTORhNAPH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateWorkflowConnectionsRpc = {
  serviceName: 'com.hubspot.multi.account.configuration.manager.rpc.MultiAccountOrganizationChirpService',
  rpcName: 'updateWorkflowConnections',
  auth: 'app',
  fingerprint: 'Cj_5E1RmhvpnTwybrcrm0cheTORhNAPH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCurrentUserOrganizationAccessRpc = {
  serviceName: 'com.hubspot.multi.account.configuration.manager.rpc.MultiAccountOrganizationChirpService',
  rpcName: 'getCurrentUserOrganizationAccess',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABv6CVP85xXxMheTORhNAPH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};